import DraggableStepCard from '../../DraggableStepCard';

export const content = ({ step }) => {
  return step.description;
};

export const getDescription = ({ step: { details }, t }) => {
  const inputs = details.inputs || [];
  const outputs = details.outputs || [];

  const description = t(
    'Run Code on ({{input}}{{restInputsCount}}) and set ({{output}}{{restOutputsCount}})',
    {
      input: inputs[0]?.name ?? t('0 inputs'),
      restInputsCount:
        inputs.length > 1
          ? t(', and {{N}} more', {
              N: inputs.length - 1,
            })
          : '',
      output: outputs[0]?.name ?? t('0 outputs'),
      restOutputsCount:
        outputs.length > 1
          ? t(', and {{N}} more', {
              N: outputs.length - 1,
            })
          : '',
    }
  );

  return description;
};

export default function CodeStepCard({ step, ...others }) {
  return <DraggableStepCard {...others}>{content({ step })}</DraggableStepCard>;
}
